import * as React from 'react';

import { Text } from '../../texts';
import { getValue } from './input-utils';
import { Styled } from './styled';

export const SearchItems = (props) => {
  const {
    isDropdownOpen,
    onChangeValue,
    activeElement,
    onBlur,
    value,
    selectedOptionRenderer = (element) => <Text>{getValue(element)}</Text>,
  } = props;

  return (
    <Styled.TextsContainer>
      {isDropdownOpen
        ? <Styled.SearchInput
            onChange={onChangeValue}
            autoFocus={true}
            onBlur={onBlur}
            value={value}
          />
        : selectedOptionRenderer(value || activeElement)
      }
    </Styled.TextsContainer>
  );
};
